routes.$inject = ['$stateProvider', '$urlRouterProvider'];

export default function routes($stateProvider, $urlRouterProvider){

	$stateProvider.state('main.account', {
		abstract: true,
		url: '/account',
		template: '<ui-view></ui-view>'
	})
}


/** WEBPACK FOOTER **
 ** ./src/main/account/routes.js
 **/